/* Promayorista theme JS - Phase B
 *
 * Vanilla JS controllers tied to Shopify Cart Ajax API + Predictive Search +
 * localStorage (wishlist). Single IIFE, no dependencies.
 */

(function () {
  'use strict';

  var routes = (window.Shopify && window.Shopify.routes) || {
    root: '/',
    cart_url: '/cart',
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_update_url: '/cart/update',
    search_url: '/search'
  };

  // ===================== Utilities =====================
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function debounce(fn, ms) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function formatMoney(cents) {
    var amount = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format(amount);
    } catch (_) {
      return '$' + Math.round(amount).toLocaleString('es-CO');
    }
  }

  // ===================== Cart count =====================
  function updateCartCount(count) {
    $$('[data-cart-count], [data-cart-drawer-count]').forEach(function (el) {
      el.textContent = count;
    });
    $$('[data-cart-count]').forEach(function (el) {
      el.classList[count > 0 ? 'remove' : 'add']('hidden');
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; })
      .catch(function () {});
  }

  // ===================== Cart drawer =====================
  function openCartDrawer() {
    var root = $('[data-cart-drawer]'), panel = $('[data-cart-drawer-panel]');
    if (!root || !panel) return;
    refreshCartDrawer();
    root.classList.remove('hidden');
    root.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { panel.classList.remove('translate-x-full'); });
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var root = $('[data-cart-drawer]'), panel = $('[data-cart-drawer-panel]');
    if (!root || !panel) return;
    panel.classList.add('translate-x-full');
    setTimeout(function () {
      root.classList.add('hidden');
      root.setAttribute('aria-hidden', 'true');
    }, 300);
    document.body.style.overflow = '';
  }

  function refreshCartDrawer() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer)
      .catch(function () {});
  }

  function renderCartDrawer(cart) {
    updateCartCount(cart.item_count);
    var itemsContainer = $('[data-cart-drawer-items]');
    var footer = $('[data-cart-drawer-footer]');
    var subtotalEl = $('[data-cart-drawer-subtotal]');
    if (!itemsContainer) return;

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);

    if (cart.item_count === 0) {
      itemsContainer.innerHTML =
        '<div class="text-center py-16 px-6">' +
          '<svg class="mx-auto h-16 w-16 text-gray-300 mb-4" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            '<circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/>' +
            '<path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>' +
          '</svg>' +
          '<p class="text-gray-700 mb-6">Tu carrito esta vacio</p>' +
          '<a href="' + routes.root + '" data-cart-drawer-close class="inline-block bg-[#FA6E30] hover:bg-[#e55d1f] text-white px-5 py-2.5 rounded-md font-medium transition-colors">Seguir comprando</a>' +
        '</div>';
      if (footer) footer.classList.add('hidden');
      return;
    }

    if (footer) footer.classList.remove('hidden');

    // Reverse: latest first
    var items = cart.items.slice().reverse();
    var html = '<ul class="divide-y divide-gray-100 m-0 p-0 list-none">';
    items.forEach(function (item) { html += renderCartDrawerLine(item); });
    html += '</ul>';
    itemsContainer.innerHTML = html;
  }

  function renderCartDrawerLine(item) {
    var img = item.image ? item.image : '';
    var title = escapeHtml(item.product_title || item.title || '');
    var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? escapeHtml(item.variant_title) : '';
    var hasCompare = item.original_line_price > item.final_line_price;
    return '' +
      '<li class="px-5 py-4" data-line-key="' + escapeHtml(item.key) + '">' +
        '<div class="flex gap-3">' +
          '<a href="' + escapeHtml(item.url) + '" data-cart-drawer-close class="block w-20 h-20 flex-shrink-0 rounded-md overflow-hidden bg-gray-100">' +
            (img ? '<img src="' + escapeHtml(img) + '" alt="' + title + '" class="w-full h-full object-cover" loading="lazy">' : '') +
          '</a>' +
          '<div class="flex-1 min-w-0 flex flex-col gap-1">' +
            '<div class="flex items-start justify-between gap-2">' +
              '<a href="' + escapeHtml(item.url) + '" data-cart-drawer-close class="font-medium text-sm text-gray-800 line-clamp-2 hover:text-[#FA6E30] flex-1">' + title + '</a>' +
              '<button type="button" class="text-gray-400 hover:text-red-500 -mr-1 -mt-1 p-1" data-cart-drawer-remove data-line-key="' + escapeHtml(item.key) + '" aria-label="Eliminar">' +
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
                  '<path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/>' +
                  '<path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>' +
                '</svg>' +
              '</button>' +
            '</div>' +
            (variantTitle ? '<p class="text-xs text-gray-500">' + variantTitle + '</p>' : '') +
            '<div class="flex items-center justify-between mt-2 gap-2">' +
              '<div class="flex items-center border border-gray-200 rounded-md">' +
                '<button type="button" class="w-7 h-7 flex items-center justify-center text-gray-600 hover:text-[#FA6E30]" data-cart-drawer-dec data-line-key="' + escapeHtml(item.key) + '" aria-label="Disminuir">' +
                  '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/></svg>' +
                '</button>' +
                '<span class="w-8 text-center text-sm text-gray-800 font-medium">' + item.quantity + '</span>' +
                '<button type="button" class="w-7 h-7 flex items-center justify-center text-gray-600 hover:text-[#FA6E30]" data-cart-drawer-inc data-line-key="' + escapeHtml(item.key) + '" aria-label="Aumentar">' +
                  '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="M12 5v14"/></svg>' +
                '</button>' +
              '</div>' +
              '<div class="text-right">' +
                (hasCompare ? '<p class="text-[10px] text-gray-400 line-through leading-none">' + formatMoney(item.original_line_price) + '</p>' : '') +
                '<p class="font-bold text-gray-800 text-sm">' + formatMoney(item.final_line_price) + '</p>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</li>';
  }

  function changeCartLineByDelta(key, delta) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = cart.items.find(function (it) { return it.key === key; });
        if (!item) return;
        var newQty = Math.max(0, item.quantity + delta);
        return setCartLineQty(key, newQty);
      });
  }

  function setCartLineQty(key, qty) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        // If we are on the /cart page, also reload to refresh the main cart UI.
        if ($('[data-cart-form]')) window.location.reload();
        return cart;
      })
      .catch(function () { showToast('Error al actualizar carrito', 'error'); });
  }

  // ===================== Add to cart (forms) =====================
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-to-cart-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;

    var fd = new FormData(form);
    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw new Error(err.description || 'Error'); });
        return r.json();
      })
      .then(function () { return refreshCartDrawer(); })
      .then(function () { openCartDrawer(); })
      .catch(function (err) { showToast(err.message || 'Error al agregar', 'error'); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  // ===================== Quantity selector (forms / cart page) =====================
  document.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-qty-dec]');
    var inc = e.target.closest('[data-qty-inc]');
    if (!dec && !inc) return;
    var src = dec || inc;
    if (src.hasAttribute('data-cart-drawer-dec') || src.hasAttribute('data-cart-drawer-inc')) return;
    var wrapper = src.closest('[data-qty-wrapper]');
    if (!wrapper) return;
    var input = wrapper.querySelector('[data-qty-input]');
    if (!input) return;

    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < 1) val = 1;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10);
    if (isNaN(max)) max = Infinity;

    if (dec) val = Math.max(min, val - 1);
    if (inc) val = Math.min(max, val + 1);
    input.value = val;

    if (src.hasAttribute('data-cart-update') || input.hasAttribute('data-cart-update')) {
      var line = wrapper.closest('[data-line-key]');
      if (line) setCartLineQty(line.getAttribute('data-line-key'), val);
    }
  });

  var debouncedCartUpdate = debounce(setCartLineQty, 400);
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-qty-input][data-cart-update]');
    if (!input) return;
    var line = input.closest('[data-line-key]');
    if (!line) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) return;
    debouncedCartUpdate(line.getAttribute('data-line-key'), qty);
  });

  // ===================== Cart drawer interactions =====================
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-open]')) {
      e.preventDefault();
      openCartDrawer();
      return;
    }
    if (e.target.closest('[data-cart-drawer-close]') || e.target.closest('[data-cart-drawer-backdrop]')) {
      closeCartDrawer();
      return;
    }
    var inc = e.target.closest('[data-cart-drawer-inc]');
    if (inc) { changeCartLineByDelta(inc.getAttribute('data-line-key'), +1); return; }
    var dec = e.target.closest('[data-cart-drawer-dec]');
    if (dec) { changeCartLineByDelta(dec.getAttribute('data-line-key'), -1); return; }
    var rm = e.target.closest('[data-cart-drawer-remove]');
    if (rm) { setCartLineQty(rm.getAttribute('data-line-key'), 0); return; }
  });

  // Cart line removal on cart page (Liquid-rendered button)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    setCartLineQty(btn.getAttribute('data-line-key'), 0);
  });

  // ===================== Generic drawers (mobile menu / filter) =====================
  function openDrawer(rootSel, panelSel) {
    var root = $(rootSel), panel = $(panelSel);
    if (!root || !panel) return;
    root.classList.remove('hidden');
    root.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { panel.classList.remove('translate-x-full'); });
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(rootSel, panelSel) {
    var root = $(rootSel), panel = $(panelSel);
    if (!root || !panel) return;
    panel.classList.add('translate-x-full');
    setTimeout(function () {
      root.classList.add('hidden');
      root.setAttribute('aria-hidden', 'true');
    }, 300);
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-menu-open]')) openDrawer('[data-mobile-menu]', '[data-mobile-menu-panel]');
    if (e.target.closest('[data-mobile-menu-close]')) closeDrawer('[data-mobile-menu]', '[data-mobile-menu-panel]');
    var mm = $('[data-mobile-menu]');
    if (mm && e.target === mm) closeDrawer('[data-mobile-menu]', '[data-mobile-menu-panel]');

    if (e.target.closest('[data-filter-open]')) openDrawer('[data-filter-drawer]', '[data-filter-drawer-panel]');
    if (e.target.closest('[data-filter-close]')) closeDrawer('[data-filter-drawer]', '[data-filter-drawer-panel]');
    var fd = $('[data-filter-drawer]');
    if (fd && e.target === fd) closeDrawer('[data-filter-drawer]', '[data-filter-drawer-panel]');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer('[data-mobile-menu]', '[data-mobile-menu-panel]');
    closeDrawer('[data-filter-drawer]', '[data-filter-drawer-panel]');
    closeSearchModal();
    closeCartDrawer();
  });

  // ===================== Search modal =====================
  function openSearchModal() {
    var root = $('[data-search-modal]'), panel = $('[data-search-modal-panel]');
    if (!root || !panel) return;
    root.classList.remove('hidden');
    root.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      panel.classList.remove('-translate-y-2', 'opacity-0');
      panel.classList.add('opacity-100');
    });
    document.body.style.overflow = 'hidden';
    setTimeout(function () {
      var input = $('[data-search-input]');
      if (input) input.focus();
    }, 100);
  }
  function closeSearchModal() {
    var root = $('[data-search-modal]'), panel = $('[data-search-modal-panel]');
    if (!root || !panel) return;
    panel.classList.add('-translate-y-2', 'opacity-0');
    panel.classList.remove('opacity-100');
    setTimeout(function () {
      root.classList.add('hidden');
      root.setAttribute('aria-hidden', 'true');
    }, 200);
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearchModal(); return; }
    if (e.target.closest('[data-search-close]')) { closeSearchModal(); return; }
    var sm = $('[data-search-modal]');
    if (sm && e.target === sm) closeSearchModal();
  });

  function handleSearchInput() {
    var input = $('[data-search-input]');
    if (!input) return;
    var q = input.value.trim();
    var clearBtn = $('[data-search-clear]');
    var loading = $('[data-search-loading]');
    var list = $('[data-search-list]');
    var empty = $('[data-search-empty]');

    if (clearBtn) clearBtn.classList[q ? 'remove' : 'add']('hidden');

    if (!q) {
      if (loading) loading.classList.add('hidden');
      if (list) { list.classList.add('hidden'); list.innerHTML = ''; }
      if (empty) {
        empty.classList.remove('hidden');
        empty.innerHTML = '<svg class="h-16 w-16 mx-auto mb-4 text-gray-300" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg><p class="text-lg font-medium">Comienza a buscar</p><p class="text-sm mt-2">Escribe el nombre del producto y presiona Enter</p>';
      }
      return;
    }

    if (empty) empty.classList.add('hidden');
    if (loading) loading.classList.remove('hidden');
    if (list) list.classList.add('hidden');

    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (loading) loading.classList.add('hidden');
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          if (list) list.classList.add('hidden');
          if (empty) {
            empty.classList.remove('hidden');
            empty.innerHTML = '<svg class="h-16 w-16 mx-auto mb-4 text-gray-300" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg><p class="text-lg font-medium">No se encontraron productos</p><p class="text-sm mt-2">Intenta con otros terminos.</p>';
          }
          return;
        }
        if (list) {
          list.innerHTML = products.map(renderSearchResult).join('');
          list.classList.remove('hidden');
        }
      })
      .catch(function () {
        if (loading) loading.classList.add('hidden');
        showToast('Error al buscar', 'error');
      });
  }

  function renderSearchResult(p) {
    var img = (p.image && (p.image.url || p.image)) || p.featured_image || '';
    var priceRaw = (p.price && p.price.amount) ? p.price.amount * 100 : (typeof p.price === 'number' ? p.price : 0);
    var price = formatMoney(priceRaw);
    var title = escapeHtml(p.title || '');
    return '<a href="' + escapeHtml(p.url) + '" class="flex items-start gap-3 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">' +
             '<img src="' + escapeHtml(img) + '" alt="' + title + '" class="w-20 h-20 object-cover rounded-md flex-shrink-0 bg-gray-100">' +
             '<div class="flex-1 min-w-0">' +
               '<h3 class="font-semibold text-base text-gray-800 line-clamp-2">' + title + '</h3>' +
               '<p class="text-lg font-bold text-purple-600 mt-1">' + price + '</p>' +
             '</div>' +
           '</a>';
  }

  // ===================== Hero carousel =====================
  function initHero(root) {
    var slides = $$('[data-hero-slide]', root);
    if (!slides.length) return;
    var dots = $$('[data-hero-dot]', root);
    var nextBtn = $('[data-hero-next]', root);
    var prevBtn = $('[data-hero-prev]', root);
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var autoplayMs = parseInt(root.getAttribute('data-autoplay-ms'), 10) || 6500;
    var index = 0, timer = null, hovering = false;

    function show(i) {
      index = ((i % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        if (n === index) {
          s.classList.add('is-active', 'opacity-100');
          s.classList.remove('opacity-0');
          if (s.getAttribute('data-confetti') === 'true') generateConfetti(s.querySelector('.confetti-container'));
        } else {
          s.classList.remove('is-active', 'opacity-100');
          s.classList.add('opacity-0');
        }
      });
      dots.forEach(function (d, n) {
        if (n === index) {
          d.classList.add('bg-white', 'scale-110');
          d.classList.remove('bg-white/50');
        } else {
          d.classList.add('bg-white/50');
          d.classList.remove('bg-white', 'scale-110');
        }
      });
    }

    function next() { show(index + 1); }
    function prev() { show(index - 1); }
    function startTimer() {
      if (!autoplay || slides.length <= 1) return;
      stopTimer();
      timer = setInterval(function () { if (!hovering) next(); }, autoplayMs);
    }
    function stopTimer() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stopTimer(); startTimer(); }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-index'), 10) || 0;
        show(i); restart();
      });
    });

    root.addEventListener('mouseenter', function () { hovering = true; });
    root.addEventListener('mouseleave', function () { hovering = false; });

    var startX = 0, startY = 0;
    root.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 80 && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) next(); else prev();
        restart();
      }
    }, { passive: true });

    show(0);
    startTimer();
  }

  function generateConfetti(container) {
    if (!container || container.childElementCount > 0) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var colors = ['#FA6E30', '#A855F7', '#4D96FF', '#6BCB77', '#FFD93D', '#FF6B6B', '#ffffff'];
    var html = '';
    for (var i = 0; i < 22; i++) {
      var driftLeft = Math.random() < 0.5;
      var left = (Math.random() * 100).toFixed(2) + '%';
      var delay = (Math.random() * 4).toFixed(2) + 's';
      var duration = (6 + Math.random() * 6).toFixed(2) + 's';
      var size = (6 + Math.random() * 12).toFixed(0) + 'px';
      var rotate = Math.floor(Math.random() * 360) + 'deg';
      var color = colors[Math.floor(Math.random() * colors.length)];
      var drift = driftLeft ? '-20vw' : '20vw';
      var rounded = Math.random() < 0.35 ? '999px' : '2px';
      html += '<span class="confetti-piece absolute block will-change-transform" style="' +
              'left:' + left + ';top:-10%;width:' + size + ';height:' + size + ';' +
              'background-color:' + color + ';transform:rotate(' + rotate + ');opacity:.95;' +
              'border-radius:' + rounded + ';filter:drop-shadow(0 2px 2px rgba(0,0,0,.18));' +
              'animation:confetti-fall ' + duration + ' linear infinite;animation-delay:' + delay + ';' +
              '--drift:' + drift + ';"></span>';
    }
    container.innerHTML = html;
  }

  // ===================== Bottom-nav swipe between pages =====================
  function initBottomNavSwipe() {
    var nav = $('[data-bottom-nav]');
    if (!nav) return;
    var pathsAttr = nav.getAttribute('data-paths');
    if (!pathsAttr) return;
    var paths;
    try { paths = JSON.parse(pathsAttr); } catch (_) { return; }
    var order = ['home', 'cart', 'categories', 'favorites', 'account'];
    var current = window.location.pathname;
    var idx = -1;
    order.forEach(function (k, i) {
      var p = paths[k] || '';
      if (!p) return;
      if (k === 'home' && (current === '/' || current === '')) idx = i;
      else if (current === p || current.indexOf(p) === 0) idx = i;
    });
    if (idx === -1) return;

    function inIgnoredZone(t) {
      return t.closest('[data-bottom-nav]') ||
             t.closest('[data-mobile-menu]') ||
             t.closest('[data-search-modal]') ||
             t.closest('[data-cart-drawer]') ||
             t.closest('[data-filter-drawer]') ||
             t.closest('[data-hero]') ||
             t.closest('input, select, textarea, button');
    }

    var startX = 0, startY = 0, tracking = false;
    document.addEventListener('touchstart', function (e) {
      if (inIgnoredZone(e.target)) { tracking = false; return; }
      tracking = true;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });

    document.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 100 || Math.abs(dx) < Math.abs(dy)) return;

      if (dx < 0 && idx < order.length - 1) {
        var n = paths[order[idx + 1]];
        if (n) window.location.href = n;
      } else if (dx > 0 && idx > 0) {
        var p = paths[order[idx - 1]];
        if (p) window.location.href = p;
      }
    }, { passive: true });
  }

  // ===================== Page size + Sort selectors =====================
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-page-size]');
    if (!btn) return;
    var url = new URL(window.location.href);
    url.searchParams.set('page_size', btn.getAttribute('data-page-size'));
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-sort-select]');
    if (!sel) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  // ===================== Filters (price ranges) =====================
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-price-filter]');
    if (!input) return;
    var url = new URL(window.location.href);
    url.searchParams.delete('filter.v.price.gte');
    url.searchParams.delete('filter.v.price.lte');
    if (input.checked) {
      var parts = input.value.split('-');
      var minVal = parts[0];
      var maxVal = parts[1];
      if (minVal) url.searchParams.set('filter.v.price.gte', minVal);
      if (maxVal) url.searchParams.set('filter.v.price.lte', maxVal);
    }
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-filter-clear]');
    if (!btn) return;
    var url = new URL(window.location.href);
    Array.from(url.searchParams.keys()).forEach(function (k) {
      if (k.indexOf('filter.') === 0) url.searchParams.delete(k);
    });
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  // ===================== Product gallery =====================
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumbnail]');
    if (!thumb) return;
    var url = thumb.getAttribute('data-image-url');
    var main = $('[data-main-image]');
    if (main && url) main.src = url;
    $$('[data-thumbnail]').forEach(function (t) { t.removeAttribute('data-active'); });
    thumb.setAttribute('data-active', 'true');
  });

  // ===================== Variant selector =====================
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-option-index]');
    if (!select) return;
    var form = select.closest('[data-variant-form]');
    if (!form) return;
    var json = $('[data-product-json]');
    if (!json) return;
    var product;
    try { product = JSON.parse(json.textContent); } catch (_) { return; }
    if (!product || !product.variants) return;

    var selected = $$('[data-option-index]', form).map(function (s) { return s.value; });
    var match = product.variants.find(function (v) {
      return v.options.every(function (val, i) { return val === selected[i]; });
    });
    if (!match) return;

    var idInput = $('[data-variant-id-input]');
    if (idInput) idInput.value = match.id;

    var url = new URL(window.location.href);
    url.searchParams.set('variant', match.id);
    history.replaceState({}, '', url.toString());
  });

  // ===================== Wishlist (localStorage) =====================
  var WL_KEY = 'pm_wishlist';
  function getWishlist() { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (_) { return []; } }
  function setWishlist(list) { try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (_) {} }
  function isInWishlist(id) { return getWishlist().some(function (it) { return String(it.id) === String(id); }); }

  function syncWishlistButtons() {
    $$('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      var icon = btn.querySelector('.wishlist-icon');
      if (!icon) return;
      if (isInWishlist(id)) {
        icon.classList.add('fill-red-500', 'text-red-500');
        icon.classList.remove('text-gray-600');
      } else {
        icon.classList.remove('fill-red-500', 'text-red-500');
        icon.classList.add('text-gray-600');
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-product-id');
    var handle = btn.getAttribute('data-product-handle');
    var title = btn.getAttribute('data-product-title') || '';
    var list = getWishlist();
    var idx = list.findIndex(function (it) { return String(it.id) === String(id); });
    if (idx >= 0) {
      list.splice(idx, 1);
      showToast('Eliminado de favoritos');
    } else {
      list.push({ id: id, handle: handle, title: title, addedAt: new Date().toISOString() });
      showToast('Agregado a favoritos');
    }
    setWishlist(list);
    syncWishlistButtons();
    if ($('[data-favorites-page]')) loadFavorites();
  });

  window.PromayoristaWishlist = { get: getWishlist, has: isInWishlist, sync: syncWishlistButtons };

  // ===================== Favorites page loader =====================
  function loadFavorites() {
    var page = $('[data-favorites-page]');
    if (!page) return;
    var list = getWishlist();
    var grid = $('[data-favorites-grid]');
    var empty = $('[data-favorites-empty]');
    var loading = $('[data-favorites-loading]');

    if (!list.length) {
      if (grid) { grid.classList.add('hidden'); grid.innerHTML = ''; }
      if (loading) loading.classList.add('hidden');
      if (empty) empty.classList.remove('hidden');
      return;
    }

    if (empty) empty.classList.add('hidden');
    if (grid) grid.classList.add('hidden');
    if (loading) loading.classList.remove('hidden');

    Promise.all(list.map(function (it) {
      if (!it.handle) return null;
      return fetch('/products/' + encodeURIComponent(it.handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      if (loading) loading.classList.add('hidden');
      products = products.filter(Boolean);
      if (!products.length) {
        if (empty) empty.classList.remove('hidden');
        return;
      }
      if (grid) {
        grid.innerHTML = products.map(renderFavoriteCard).join('');
        grid.classList.remove('hidden');
        syncWishlistButtons();
      }
    });
  }

  function renderFavoriteCard(p) {
    var price = formatMoney(p.price);
    var hasCompare = p.compare_at_price && p.compare_at_price > p.price;
    var original = hasCompare ? formatMoney(p.compare_at_price) : '';
    var pct = hasCompare ? Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) : 0;
    var img = p.featured_image || (p.images && p.images[0]) || '';
    var title = escapeHtml(p.title || '');
    return '' +
      '<article class="product-card bg-white rounded-xl shadow-sm overflow-hidden flex flex-col relative group" data-product-id="' + p.id + '">' +
        '<a href="' + escapeHtml(p.url) + '" class="block">' +
          '<div class="relative aspect-square overflow-hidden bg-gray-100">' +
            '<img src="' + escapeHtml(img) + '" alt="' + title + '" class="product-image w-full h-full object-cover" loading="lazy">' +
            (pct > 0 ? '<div class="absolute top-2 left-2 px-2 py-0.5 rounded-full text-xs font-bold shadow text-white bg-[#FA6E30]">-' + pct + '%</div>' : '') +
          '</div>' +
        '</a>' +
        '<div class="p-3 sm:p-4 flex flex-col flex-grow space-y-2">' +
          '<a href="' + escapeHtml(p.url) + '"><h3 class="font-semibold text-sm text-gray-800 line-clamp-2 min-h-[2.5rem]">' + title + '</h3></a>' +
          '<div class="flex items-baseline gap-2">' +
            '<span class="text-lg font-bold text-[#FA6E30]">' + price + '</span>' +
            (original ? '<span class="text-xs text-gray-400 line-through">' + original + '</span>' : '') +
          '</div>' +
          '<button type="button" class="w-full text-xs text-gray-500 hover:text-red-600 inline-flex items-center justify-center gap-1 mt-1" data-wishlist-toggle data-product-id="' + p.id + '" data-product-handle="' + escapeHtml(p.handle || '') + '" data-product-title="' + title + '">' +
            'Quitar de favoritos' +
          '</button>' +
        '</div>' +
      '</article>';
  }

  // ===================== Toast =====================
  var toastEl = null, toastT = null;
  function ensureToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.setAttribute('role', 'status');
    toastEl.setAttribute('aria-live', 'polite');
    toastEl.style.cssText = 'position:fixed;bottom:5.5rem;left:50%;transform:translateX(-50%) translateY(20px);z-index:100;padding:.5rem 1rem;border-radius:.5rem;color:#fff;font-size:.875rem;box-shadow:0 10px 25px -5px rgba(0,0,0,.2);opacity:0;transition:opacity .25s,transform .25s;pointer-events:none;max-width:90vw;text-align:center;';
    document.body.appendChild(toastEl);
    return toastEl;
  }
  function showToast(msg, variant) {
    var el = ensureToast();
    el.textContent = msg;
    el.style.background = variant === 'error' ? '#dc2626' : '#FA6E30';
    el.style.opacity = '1';
    el.style.transform = 'translateX(-50%) translateY(0)';
    if (toastT) clearTimeout(toastT);
    toastT = setTimeout(function () {
      el.style.opacity = '0';
      el.style.transform = 'translateX(-50%) translateY(20px)';
    }, 2500);
  }

  // ===================== Init =====================
  document.addEventListener('DOMContentLoaded', function () {
    syncWishlistButtons();
    fetchCart();
    $$('[data-hero]').forEach(initHero);
    initBottomNavSwipe();
    loadFavorites();

    var input = $('[data-search-input]');
    if (input) input.addEventListener('input', debounce(handleSearchInput, 300));
    var clearBtn = $('[data-search-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        var inp = $('[data-search-input]');
        if (inp) { inp.value = ''; handleSearchInput(); inp.focus(); }
      });
    }
  });
})();
